var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.card},[_c('div',{class:_vm.$style.image},[(_vm.project.image)?_c('img',{attrs:{"src":_vm.project.image.fullPath}}):_vm._e()]),_c('div',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.project.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }